import config from "../../config";

const state = {
  username: '__REPLACE_USERNAME__',
  server: config.WEBSOCKET_URL,
  authToken: config.AUTH_TOKEN,
  domain: config.SITE
}

const getters = {
  getUsername (state) {
    return state.username
  },
  getServer (state) {
    return  state.server
  },
  getToken (state) {
    return state.authToken
  },
  getDomain (state) {
    return state.domain
  }
}

const mutations = {
  setUsername (state, username) {
    state.username = username
  },
  setServer (state, server) {
    state.server = server
  }
}

const actions = {
  setUsername (context, username) {
    context.commit('setUsername', username)
  },
  setServer (context, server) {
    context.commit('setServer', server)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
